
// import "core-js";
import "regenerator-runtime/runtime";

import 'video.js';
import '../css/main.css.scss';
import './create_videojs.js';
import '../videojs-contrib-hls.js/src/videojs5.hlsjs.js';
import '../videojs-contrib-hls.js/lang/ru.js';
import '../videojs-contrib-hls.js/lang/en.js';

import '../videojs-quality-switcher/src/videojs-quality-switcher.js';
import '../videojs-quality-switcher/lang/ru.js';
import '../videojs-quality-switcher/lang/en.js';

import '../videojs-stat/src/videojs-stat.js';

import '../videojs-feedback/lang/ru.js';
import '../videojs-feedback/lang/en.js';
import '../videojs-feedback/src/videojs-feedback.js';

import '../videojs-countdown-start/lang/ru.js';
import '../videojs-countdown-start/lang/en.js';
import '../videojs-countdown-start/src/videojs-countdown-start.js';

import '../videojs-moments/lang/ru.js';
import '../videojs-moments/lang/en.js';
import '../videojs-moments/src/videojs-moments.js';

import '../videojs-audiotracks/lang/ru.js';
import '../videojs-audiotracks/lang/en.js';
import '../videojs-audiotracks/src/videojs-audiotracks.js';

import '../videojs-postmessages/src/videojs-postmessages.js';

import '../videojs-suggested/videojs.suggestedVideoEndcap.js';
import '../videojs-hotkeys/videojs.hotkeys.js';
import '../videojs-persistvolume/videojs.persistvolume.js';

import './main_skin.js';
import './wcr_player.js';
import './wcr_api.js';
import './custom_css.js';
import './live_button.js';
import './seek_locker.js';

import './ws-messages/videojs-ws-messages.js';
import './ws-messages/lang/ru.js';
import './ws-messages/lang/en.js';

import './access_code/videojs-access_code.js';
import './access_code/lang/ru.js';
import './access_code/lang/en.js';

import './like-button/videojs-like-button.js';
import './videojs-link/src/videojs-link.js';

import './lang/en.js';
import './lang/ru.js';

import './flockplay.js';
import './replay/videojs-replay.js';

import './share/videojs-share.js';
import './share/lang/ru.js';
import './share/lang/en.js';

import './current-online/current-online.js';

// import './resize-progress/videojs-resize-progress.js';

import './adblockers_detector/lang/en.js';
import './adblockers_detector/lang/ru.js';
import './adblockers_detector/videojs-adblockers_detector.js';

// import 'videojs-contrib-dash/lang/en.js';
// import 'videojs-contrib-dash/lang/ru.js';
import '../videojs-contrib-dash/src/js/videojs-dash.js';

import '../videojs-logo/src/videojs-logo.js';

import '../videojs-vast-vpaid/src/scripts/videojs_5.vast.vpaid.js';
import '../videojs-vast-vpaid/lang/en.js';
import '../videojs-vast-vpaid/lang/ru.js';

import '../videojs-settings/src/plugin.js';

import '../videojs-airplay/src/videojs-airplay.js';

import '../videojs-big-controls/src/videojs-big-controls';

import './analitics/videojs-analitics.js';
import '../videojs-custom-colors/src/videojs-custom-colors.js';
import '../videojs-custom-info/src/videojs-custom-info.js';
import '../videojs-multicam/src/videojs-multicam.js';
import '../videojs-events-on-timeline/src/videojs-events-on-timeline.js';

import '../videojs-settings-group/lang/ru.js';
import '../videojs-settings-group/lang/en.js';
import '../videojs-settings-group/src/videojs-settings-group.js';

// import '../videojs-mini-progress/src/videojs-mini-progress.js';
import '../videojs-timeline-preview/src/videojs-timeline-preview.js';
import './restriction-modal/src/restriction-modal-dialog.js';
// import './matchtv/controls-to-right.js';
import '../videojs-group-with-quality/lang/en.js';
import '../videojs-group-with-quality/lang/ru.js';
import '../videojs-group-with-quality/src/videojs-group-with-quality.js';

import './button-group/videojs-button-group.js';
import './promo-code/videojs-promo-code.js';
import './state-reporter/state-reporter.js';

import './css-breakpoints.js';
import './svg_clip/videojs-svg-clip.js';

import '../videojs-chat/src/videojs-chat.js';
import '../videojs-blur-background/src/videojs-blur-background.js';
import '../videojs-stream-shopping/src/videojs-stream-shopping.js';
import './thin-and-align/videojs-thin-and-align.js';
import './label-image';
import './image-link/index.js';
import './prevent_direct_actions_with_tech';

import '../videojs-notification/src/videojs-notification.js';

import './videojs-games/src/videojs-games.js';
import './videojs-games/lang/ru.js';
import './videojs-games/lang/en.js';

import '../videojs-rotate-screen/src/videojs-rotate-screen.js';

import './show_controls_before_playback/src/videojs-show-controls-before-playback.js';

import './switch-seasons-and-episodes/lang/ru.js';
import './switch-seasons-and-episodes/lang/en.js';
import './switch-seasons-and-episodes/src/videojs-switch-seasons-and-episodes.js';

import './videojs-sticker/videojs-sticker.js';

import './matchtv/src/matchtv.js';

import './display-calendar-time/display-calendar-time.js';
import './hls-channel-monitoring/hls-channel-monitoring.js';

console.log('light ready');
